/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AktSucheDataRetrieveResponse } from '../models/akt-suche-data-retrieve-response';
import { AktSucheListRetrieveRequest } from '../models/akt-suche-list-retrieve-request';
@Injectable({
  providedIn: 'root',
})
class AktsucheService extends __BaseService {
  static readonly aktsucheRetrieveCreatePath = '/aktsuche/retrieve';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  aktsucheRetrieveCreateResponse(data: AktSucheListRetrieveRequest): __Observable<__StrictHttpResponse<Array<AktSucheDataRetrieveResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/aktsuche/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AktSucheDataRetrieveResponse>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  aktsucheRetrieveCreate(data: AktSucheListRetrieveRequest): __Observable<Array<AktSucheDataRetrieveResponse>> {
    return this.aktsucheRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as Array<AktSucheDataRetrieveResponse>)
    );
  }
}

module AktsucheService {
}

export { AktsucheService }
